import { render } from "./AccountVerify.vue?vue&type=template&id=603edd64"
import script from "./AccountVerify.vue?vue&type=script&lang=js"
export * from "./AccountVerify.vue?vue&type=script&lang=js"

import "./AccountVerify.vue?vue&type=style&index=0&id=603edd64&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__